var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-toolbar',{staticClass:"white",attrs:{"fixed":""}},[_c('img',{staticClass:"logo",attrs:{"src":"public/dark_logo_transparent.svg","alt":"Studied Solutions"}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('span',[_vm._v("© 2018 Studied Solutions, LLC.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c527d88e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 22
// module chunks = 0